import request from "@/utils/request";

export default function agentGetMantenanceMan(params) {
    return request({
        url: `/user/maintenanceMan/agentGetMantenanceMan`,
        params: params
    })
}
